import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=5587a1e6&"
import script from "./purchase.vue?vue&type=script&lang=ts&"
export * from "./purchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports